/**
 * @format
 */

 export const LOADING_CLIENT_DETAILS = 'loading_client_details';
 export const ADD_CLIENT = 'add_client';
